export default __webpack_public_path__ + "static/media/seb.e9778359.JPG";